module.exports = {
  env: "development",
  api: "http://localhost:3000/api/v1.0.0",
};
